import * as React from 'react';

import SyncIcon from '@mui/icons-material/Sync';

import CustomButton from 'components/Button';

interface SyncButtonProps {
  onClick: () => void;
  disabled?: boolean;
}
function SyncButton({ onClick, disabled }: SyncButtonProps) {
  return (
    <CustomButton
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      width="medium"
      text="Sync"
      endIcon={<SyncIcon />}
    />
  );
}

export default SyncButton;
